import React from "react";
import "./CustomButton.css";

const CustomButton = ({ btnName, link, target = "_self" }) => {
  return (
    <a 
      className="custbtn btn-large waves-effect waves-light" 
      href={link}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
    >
      {btnName}
    </a>
  );
};

export default CustomButton;
